export function getPackageRemainingCount(product) {
  const count = Number(product?.count || 0);
  const reserved = Number(product?.reserved || 0);
  if (!Number.isFinite(count) || !Number.isFinite(reserved)) {
    return 0;
  }
  return Math.max(count - reserved, 0);
}

export function canReservePackage(product) {
  const hasRemainingSeats = getPackageRemainingCount(product) > 0;
  const canBookFreeProduct = Number(product?.price || 0) !== 0 || Boolean(product?.allow_free_booking);
  return hasRemainingSeats && canBookFreeProduct;
}

export function getPackageRemainingLabel(product) {
  return `잔여 ${getPackageRemainingCount(product)} / 총 ${Number(product?.count || 0)}`;
}

export function shouldEnterOptionStep({ selectedSeatCount, hasSelectableOptions, isOptionStep }) {
  return Number(selectedSeatCount || 0) > 0 && Boolean(hasSelectableOptions) && !isOptionStep;
}

function isOptionForSeat(option, seat) {
  if (option?.seatKey || seat?.clientKey) {
    return option?.seatKey === seat?.clientKey;
  }
  return option?.spotId === seat?.id;
}

export function getOptionPersonnelValidation({ product, seats = [], options = [] }) {
  if (!product?.option_required || product?.option_required_type !== "extra") {
    return null;
  }

  const minPersonnel = Number(product?.std_personnel || 0);
  const maxPersonnel = Number(product?.max_personnel || 0);

  for (const seat of seats) {
    const personCount = options.filter((option) => option?.type === "extra" && isOptionForSeat(option, seat)).length;

    if (minPersonnel > 0 && personCount < minPersonnel) {
      return {
        type: "min",
        message: `한 테이블당 최소 ${minPersonnel}명 이상 선택해 주세요.`,
      };
    }

    if (maxPersonnel > 0 && personCount > maxPersonnel) {
      return {
        type: "max",
        message: `옵션 선택 인원이 최대 인원을 초과했습니다. ${personCount} / ${maxPersonnel}명`,
      };
    }
  }

  return null;
}
